import { NOOP_VOID } from 'wdc-cube';
import { Places } from '../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'mn';
/** Os atributos deste place: viajam na intencao, mas nao vao para o endereco. */
const A = {
    parentSlot: `${PREFIX}a`,
    dialogSlot: `${PREFIX}b`
};
/**
 * A base que as keys dos outros modulos estendem.
 *
 * Uma classe de keys e a face tipada de um intent: diz quais parametros um place
 * entende, e e o unico lugar que conhece os nomes deles. Um presenter le e
 * escreve por aqui e nunca toca na URL.
 */
export class MainKeys {
    constructor(app, intent) {
        this._app = app;
        this._intent = intent ?? app.newFlipIntent(this.place);
    }
    /**
     * Chaves do PROPRIO place, com o estado atual da aplicacao dentro.
     *
     * `newFlipIntent` pergunta a cada presenter VIVO o que ele mostra
     * (`publishParameters`), entao o intent nasce com os filtros, a ordenacao e a
     * pagina que estao na tela - sem ninguem copiar campo a campo, e sem reparsear
     * a URL, que e a mesma informacao em forma pior.
     *
     * Viajar para QUALQUER place parte daqui, e nao ha o que limpar: cada parametro
     * tem um dono unico (ver o cabecalho de `route-consts.ts`), e quem nao entra na composicao vencedora
     * e liberado da memoria - deixa de publicar, e o nome dele desaparece do
     * endereco. O que o destino nao entende, ele nao le.
     *
     *     await CompaniesKeys.of(this.app).flip()
     *
     * A tipagem de `this` como construtor e o que faz o retorno ser a subclasse, e
     * nao `MainKeys`.
     */
    static of(app) {
        return new this(app);
    }
    get place() {
        return Places.main;
    }
    get targetPlace() {
        return this._intent.place;
    }
    flip() {
        return this._app.flipToIntent(this._intent);
    }
    toString() {
        return this._intent.toString();
    }
    // :: Slots
    get parentSlot() {
        return this._intent.getScopeSlot(A.parentSlot) ?? NOOP_VOID;
    }
    set parentSlot(value) {
        this._intent.setScopeSlot(A.parentSlot, value);
    }
    get dialogSlot() {
        return this._intent.getScopeSlot(A.dialogSlot) ?? NOOP_VOID;
    }
    set dialogSlot(value) {
        this._intent.setScopeSlot(A.dialogSlot, value);
    }
}
//# sourceMappingURL=main.key.js.map